import StandardInput from './StandardInput';

export default StandardInput;